// extracted by mini-css-extract-plugin
export default {"closeButton":"closeButton__1qm9M"};